export default function (element, data) {
    element.querySelector('.video__link').addEventListener('click', async function(e) {
        let imageBlock = element.querySelector('.media__block_image');
        let btnElement = element.querySelector('.video__link');
        let bgBlock = element.querySelector('.media__block_bg');
        let video = element.querySelector("video");
        let videoBlock = element.querySelector(".video-block");

        videoBlock.classList.remove('hidden');
        btnElement.classList.add('hidden');

        if (imageBlock) imageBlock.classList.add('hidden');
        if (bgBlock) bgBlock.classList.add('hidden');

        if (video) {
            video.muted = false;
            video.controls = true;
            video.loop = false;

            // if (video.requestFullscreen) {
            //     await video.requestFullscreen();
            // } else if (video.webkitRequestFullscreen) {
            //     await video.webkitRequestFullscreen();
            // } else if (video.msRequestFullscreen) {
            //     await video.msRequestFullscreen();
            // }

            video.play();
        }
    });

}